/**
 * @file コンポーネント：フル動画ページローディングエラーモーダル スタイル管理
 */

// ライブラリ読み込み
import styled from "styled-components";

// スタイル

export const StyledErrorLoadingAnchor = styled.a`
    color: #007dff;
    text-decoration: underline;
`;
